import axios from "axios";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// Public API instance - no credentials, no auth interceptors
export const publicApi = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: { "Content-Type": "application/json" },
});
